<div
    class="form-label font-sm weight-medium pb-0 mb-0"
    [ngClass]="{ error: error }"
>
    {{ label }}&nbsp;
</div>
<div
    class="input-group-wrapper"
    [ngClass]="{
        maxwidth: hasMaxInputWidth,
    }"
>
    <div class="input-group" [ngClass]="{ error: error }">
        <input
            type="number"
            class="form-control font-sm pt-0 pb-0 ps-1 pe-1"
            [class.pe-4]="errorIcon()"
            [ngClass]="{
                highlight: showHighlightPulse,
                maxwidth: hasMaxInputWidth,
            }"
            [ngModel]="formatValue(value)"
            (ngModelChange)="onInputChange($event)"
            (blur)="onInputChange(value?.toString())"
            (input)="validateInput($event)"
            (keypress)="restrictKeys($event)"
            [disabled]="!isEnabled"
            [placeholder]="placeholder"
        />
        <span class="input-group-selector d-flex flex-column">
            <button
                class="btn btn-spinner"
                type="button"
                (click)="increaseValue()"
                [disabled]="!isEnabled"
            >
                <i class="fa-solid fa-caret-up fa-sm"></i>
            </button>
            <button
                class="btn btn-spinner"
                type="button"
                (click)="decreaseValue()"
                [disabled]="!isEnabled"
            >
                <i class="fa-solid fa-caret-down fa-sm"></i>
            </button>
        </span>
    </div>
    @if (errorIcon() && error) {
        <div class="d-flex align-middle align-items-center icon-wrapper">
            <div
                class="d-flex bg-icon-div"
                [ngbTooltip]="errorMessage()"
                container="body"
            >
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
            </div>
        </div>
    }
</div>
